(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-splash"]) return;
  try {
    class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    this.elements.button.addEventListener(
      'click',
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      'focusout',
      this.closeSelector.bind(this)
    );
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute(
      'aria-expanded',
      (
        this.elements.button.getAttribute('aria-expanded') === 'false'
      ).toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-splash"]) return;
  try {
    class SiteHeader extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.header = document.getElementById('shopify-section-header-splash');
    if (!this.header) return;
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.predictiveSearch = this.querySelector('predictive-search');
    if (this.getAttribute('data-overlay')) {
      this.checkOverlay();
      window.addEventListener('checkOverlay', this.checkOverlay.bind(this));
    } else {
      const main = document.getElementById('MainContent');
      main.classList.remove('has-overlay');
      return;
    }

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    window.addEventListener('resize', this.handleResize.bind(this));
    //init

    // this.handleResize();
    // this.handleResize()
    window.addEventListener('load', this.handleResize.bind(this));
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;

    this.checkOverlayActive()
  }

  checkOverlayActive() {
    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (this.overlay) {
      const self = this;
      if (scrollTop > this.overlayLine) {
        requestAnimationFrame(function () {
          self.header.classList.remove('overlay-active');
        });
      } else if (scrollTop < this.overlayLine) {
        requestAnimationFrame(function () {
          self.header.classList.add('overlay-active');
        });
      }
    }
  }

  hide() {
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
  checkOverlay() {
    //Checking overlay
    if (this.pageHasOverlay()) {
      this.overlay = true;
      this.header.classList.add('has-overlay');
    }
    this.checkOverlaySize();
    window.addEventListener('resize', this.checkOverlaySize.bind(this));
  }

  pageHasOverlay() {
    let main = document.getElementById('MainContent');
    //fix multi mains from barba;
    const multiMains = document.querySelectorAll('main.main-content');

    if (multiMains && multiMains.length > 1) {
      main = multiMains[multiMains.length - 1];
    }
    const children = main.querySelectorAll('.shopify-section');
    if (children && children[0].classList.contains('image-section')) {
      this.overlaySection = children[0];
      main.classList.add('has-overlay');
      return true;
    } else {
      main.classList.remove('has-overlay');
      return false;
    }
  }

  handleResize() {
    if (this.overlay) {
      this.checkOverlaySize();
    }
    (this.headerBounds = {
      top: this.header.offsetTop,
      bottom: this.header.offsetTop + this.header.offsetHeight,
    }),
      document.body.style.setProperty(
        '--header-bottom',
        this.header.offsetHeight + this.header.offsetTop - 2 + 'px'
      );
  }

  checkOverlaySize() {
    if (this.overlaySection) {
      const overlayBounds = this.overlaySection.getBoundingClientRect();
      this.overlayLine = overlayBounds.bottom;
    } else {
      return 0;
    }
  }
}

customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    class SiteHeader extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const self = this;
    this.header = document.querySelector(
      ":not(.sidebar__inner) > .section-site-header",
    );

    this.header.addEventListener(
      "shopify:section:load",
      this.handleResize.bind(this),
    );

    window.addEventListener("resize", this.handleResize.bind(this));
    window.addEventListener("load", () =>
      setTimeout(() => self.handleResize.bind(self), 500),
    );

    if (!this.header) return;

    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.predictiveSearch = this.querySelector("predictive-search");
    if (this.getAttribute("data-overlay")) {
      this.checkOverlay();
      window.addEventListener("checkOverlay", this.checkOverlay.bind(this));
    } else {
      const main = document.getElementById("MainContent");
      main.classList.remove("has-overlay");
    }

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScrollHandler, false);
    this.onScroll();
    this.handleResize();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize.bind(this));
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;

    this.checkOverlayActive();
  }

  checkOverlayActive() {
    const scrollTop = document.documentElement.scrollTop;

    if (this.overlay) {
      const self = this;
      if (scrollTop > this.overlayLine) {
        requestAnimationFrame(function () {
          self.header.classList.remove("overlay-active");
        });
      } else if (scrollTop < this.overlayLine) {
        requestAnimationFrame(function () {
          self.header.classList.add("overlay-active");
        });
      }
    }
  }

  hide() {
    this.header.classList.add(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
    );
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.remove("shopify-section-header-hidden");
    this.header.classList.add("shopify-section-header-sticky", "animate");
  }

  reset() {
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate",
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll("details-disclosure");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector("details-modal");
    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
  checkOverlay() {
    //Checking overlay
    if (this.pageHasOverlay()) {
      this.overlay = true;
      this.header.classList.add("has-overlay");
    }
    this.checkOverlaySize();
  }

  pageHasOverlay() {
    let main = document.getElementById("MainContent");

    if (this.getAttribute("data-overlay") !== "true") {
      main.classList.remove("has-overlay");
      return false;
    }
    //fix multi mains from barba;
    const multiMains = document.querySelectorAll("main.main-content");

    if (multiMains && multiMains.length > 1) {
      main = multiMains[multiMains.length - 1];
    }
    const children = main.querySelectorAll(".shopify-section");
    if (children && children[0].classList.contains("image-section")) {
      this.overlaySection = children[0];
      main.classList.add("has-overlay");
      return true;
    } else if (this.nextElementSibling.classList.contains("image-section")) {
      this.overlaySection = this.nextElementSibling;
      return true;
    } else {
      main.classList.remove("has-overlay");
      return false;
    }
  }

  handleResize() {
    this.checkOverlay();
    if (this.overlay) {
      this.checkOverlaySize();
    }
    this.headerBounds = {
      top: this.header.offsetTop,
      bottom: this.header.offsetTop + this.header.offsetHeight,
    };
    document.body.style.setProperty(
      "--header-bottom",
      this.header.offsetHeight + this.header.offsetTop + "px",
    );
  }

  checkOverlaySize() {
    if (this.overlaySection) {
      const overlayBounds = this.overlaySection.getBoundingClientRect();
      this.overlayLine = overlayBounds.bottom;
      document.body.style.setProperty(
        "--hero-bottom",
        overlayBounds.bottom + "px",
      );
    } else {
      document.body.style.removeProperty("--hero-bottom");
      return 0;
    }
  }
}

customElements.define("site-header", SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(
      `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
        'data-media-id'
      )}"])`
    ).forEach((element) => {
      element.classList.remove('active');
    });
    const activeMedia = this.querySelector(
      `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
    );
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate
      ? activeMediaTemplate.content
      : null;
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (
      activeMedia.nodeName == 'DEFERRED-MEDIA' &&
      activeMediaContent &&
      activeMediaContent.querySelector('.js-youtube')
    )
      activeMedia.loadContent();
  }
}

if (!customElements.get('product-modal'))
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
